import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_399: DocMigration = {
  maxSchemaVersion: "0.0.399",
  description: "Moves properties from RoofDormerPlacement to DormerSettings",
  apply(json: any) {
    const { dormers } = json;

    const fieldsToMove = [
      "side",
      "horizontalPositions",
      "normalizedPositions",
      "verticalPosition",
      "width",
      "height",
      "frontOffset",
      "start",
      "end",
      "spacing",
      "truncationType",
      "truncationHeightFactor",
      "truncationNormalizedHeight",
      "truncationSlopeType",
      "truncationSlope",
      "includeRidgeVent",
    ];

    // roof instances
    for (const dormerId in dormers) {
      const dormer = dormers[dormerId];
      if (!dormer.dormerSettings) {
        dormer.dormerSettings = {};
      }
      Object.keys(dormer).forEach((key) => {
        if (fieldsToMove.includes(key)) {
          dormer.dormerSettings[key] = dormer[key];
          delete dormer[key];
        }
      });
    }

    return json;
  },
};

export default migration_0_0_399;
